// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.Exporting.js" company="Izenda">  Copyright (c) 2015
// Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------

import React from 'react';

import connect from 'share/enhancers/Izenda.Connect';
import Panel from 'share/components/controls/Izenda.Panel';
import GridLayout from 'share/components/controls/Izenda.GridLayout';
import RightPanelContent from './Izenda.RightPanelContent';
import Header from './Izenda.Header';
import LicenseCheckerConstants from 'logic/data/Izenda.LicenseCheckerConstants';

const Exporting = connect()(props => {
 const { model, localization, authorization } = props;
  const header = {
    component: Header,
    headerName: localization.getText('COMMON_LABEL_EXPORTING'),
    model
  };
  const hasIframeLicense = authorization.checkLicense(LicenseCheckerConstants.LICENSE_KEY.Iframe);
  const className = 'grid-small-column u_borderRight u-bgWhite';
  return (
    <Panel
      className='u_fullHeight u_noMarginAll u_noPaddingAll u_noBorder'
      header={header}
      collapsible
      expanedOption={model.collapseAll}
    >
      <GridLayout>
        <GridLayout.Row className='u_noMarginAll u_borderTop'>
          <GridLayout.Col cols='12' className='u_noPaddingAll u-bgGrayBlue'>
            <GridLayout.Col cols='3' className={className}>
              <div>
                <span className='u_smallIcon u_alignMiddle'>&#9899;</span>
                <span>{localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_LABEL_WORD')}</span>
              </div>
            </GridLayout.Col>
            <RightPanelContent model={model} keysPath='exporting.exportingFormat.word' />
          </GridLayout.Col>
        </GridLayout.Row>

        <GridLayout.Row className='u_noMarginAll u_borderTop'>
          <GridLayout.Col cols='12' className='u_noPaddingAll u-bgGrayBlue'>
            <GridLayout.Col cols='3' className={className}>
              <div>
                <span className='u_smallIcon u_alignMiddle'>&#9899;</span>
                <span>{localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_LABEL_EXCEL')}</span>
              </div>
            </GridLayout.Col>
            <RightPanelContent model={model} keysPath='exporting.exportingFormat.excel' />
          </GridLayout.Col>
        </GridLayout.Row>

        <GridLayout.Row className='u_noMarginAll u_borderTop'>
          <GridLayout.Col cols='12' className='u_noPaddingAll u-bgGrayBlue'>
            <GridLayout.Col cols='3' className={className}>
              <div>
                <span className='u_smallIcon u_alignMiddle'>&#9899;</span>
                <span>{localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_LABEL_PDF')}</span>
              </div>
            </GridLayout.Col>
            <RightPanelContent model={model} keysPath='exporting.exportingFormat.pdf' />
          </GridLayout.Col>
        </GridLayout.Row>

        <GridLayout.Row className='u_noMarginAll u_borderTop'>
          <GridLayout.Col cols='12' className='u_noPaddingAll u-bgGrayBlue'>
            <GridLayout.Col cols='3' className={className}>
              <div>
                <span className='u_smallIcon u_alignMiddle'>&#9899;</span>
                <span>{localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_LABEL_CSV')}</span>
              </div>
            </GridLayout.Col>
            <RightPanelContent model={model} keysPath='exporting.exportingFormat.csv' />
          </GridLayout.Col>
        </GridLayout.Row>

        <GridLayout.Row className='u_noMarginAll u_borderTop'>
          <GridLayout.Col cols='12' className='u_noPaddingAll u-bgGrayBlue'>
            <GridLayout.Col cols='3' className={className}>
              <div>
                <span className='u_smallIcon u_alignMiddle'>&#9899;</span>
                <span>{localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_LABEL_XML')}</span>
              </div>
            </GridLayout.Col>
            <RightPanelContent model={model} keysPath='exporting.exportingFormat.xml' />
          </GridLayout.Col>
        </GridLayout.Row>

        <GridLayout.Row className='u_noMarginAll u_borderTop'>
          <GridLayout.Col cols='12' className='u_noPaddingAll u-bgGrayBlue'>
            <GridLayout.Col cols='3' className={className}>
              <div>
                <span className='u_smallIcon u_alignMiddle'>&#9899;</span>
                <span>{localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_LABEL_JSON')}</span>
              </div>
            </GridLayout.Col>
            <RightPanelContent model={model} keysPath='exporting.exportingFormat.json' />
          </GridLayout.Col>
        </GridLayout.Row>

        <GridLayout.Row className='u_noMarginAll u_borderTop'>
          <GridLayout.Col cols='12' className='u_noPaddingAll u-bgGrayBlue'>
            <GridLayout.Col cols='3' className={className}>
              <div>
                <span className='u_smallIcon u_alignMiddle'>&#9899;</span>
                <span>{localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_LABEL_QUERY_EXECUTION')}</span>
              </div>
            </GridLayout.Col>
            <RightPanelContent model={model} keysPath='exporting.exportingFormat.queryExecution' />
          </GridLayout.Col>
        </GridLayout.Row>
      </GridLayout>
      <GridLayout.Row className='u_noMarginAll u_borderTop'>
        <GridLayout.Col cols='12' className='u_noPaddingAll u-bgGrayBlue'>
          <GridLayout.Col cols='3' className={className}>
            <div>
              <span className='u_smallIcon u_alignMiddle'>&#9899;</span>
              <span>{localization.getText('PERMISSION_LABEL_DEFINITION')}</span>
            </div>
          </GridLayout.Col>
          <RightPanelContent model={model} keysPath='exporting.exportingFormat.definition' />
        </GridLayout.Col>
      </GridLayout.Row>

      {hasIframeLicense && (
        <GridLayout.Row className="u_noMarginAll u_borderTop">
          <GridLayout.Col cols="12" className="u_noPaddingAll u-bgGrayBlue">
            <GridLayout.Col cols="3" className={className}>
              <div>
                <span className="u_smallIcon u_alignMiddle">&#9899;</span>
                <span>{localization.getText('PERMISSION_LABEL_IFRAME')}</span>
              </div>
            </GridLayout.Col>
            <RightPanelContent model={model} keysPath="exporting.exportingFormat.iframe" />
          </GridLayout.Col>
        </GridLayout.Row>
      )}
    </Panel>
  );
});

export default Exporting;



// WEBPACK FOOTER //
// ./ui/modules/Settings/RoleSetup/RoleDetail/PermissionSummary/Izenda.Exporting.js